import { FIELD_TYPE } from "@saleor/components/FormField/constants";
import { FormikProps } from "formik";
import { useMemo } from "react";
import { useIntl } from "react-intl";

import useStyles from "./styles";
import { getSalesPartnerMapping } from "./utils";

const useNotRefSales = (
  showDetails: boolean,
  formik: FormikProps<any>,
  salesGroup,
  isChangeFlow,
  isViewMode,
  salesDataloadingCompleted
) => {
  const intl = useIntl();
  const classes = useStyles();

  const salesOrganizationList = getSalesPartnerMapping(
    formik?.values?.salesOrganizationList
  );
  const distributionChannelList = getSalesPartnerMapping(
    formik?.values?.distributionChannelList
  );
  const divisionList = getSalesPartnerMapping(formik?.values?.divisionList);

  const salesGroupList = getSalesPartnerMapping(salesGroup);

  const orderTypeList = [
    { value: "ZP20", label: "ZP20 - Cash" },
    { value: "ZP30", label: "ZP30 - Credit" }
  ];

  const formSalesData = useMemo(
    () => [
      {
        title: intl.formatMessage({ defaultMessage: "Order Type" }),
        name: isChangeFlow && isViewMode ? "orderTypeDisplayText" : "orderType",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "Order Type"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: orderTypeList,
        md: 12,
        isfieldVisibility: !showDetails,
        isDisabled: isChangeFlow && !isViewMode
      },
      {
        title: intl.formatMessage({ defaultMessage: "Sales Organization" }),
        name:
          isChangeFlow && isViewMode
            ? "salesOrganizationName"
            : "salesOrganizationCode",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "Sales Organization"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: salesOrganizationList,
        md: 12,
        isDisabled:
          Boolean(showDetails) ||
          (isChangeFlow && !isViewMode) ||
          (!(salesOrganizationList.length > 0) && salesDataloadingCompleted)
      },
      {
        title: intl.formatMessage({ defaultMessage: "Distribution Channel" }),
        name:
          isChangeFlow && isViewMode
            ? "distributionChannelName"
            : "distributionChannelCode",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "Distribution Channel"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: distributionChannelList,
        md: 12,
        isDisabled:
          Boolean(showDetails) ||
          (isChangeFlow && !isViewMode) ||
          (salesOrganizationList.length <= 0 && salesDataloadingCompleted)
      },
      {
        title: intl.formatMessage({ defaultMessage: "Division" }),
        name: isChangeFlow && isViewMode ? "divisionCodeName" : "divisionCode",
        required: true,
        placeholder: intl.formatMessage({
          defaultMessage: "Division"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: divisionList,
        md: 12,
        isDisabled:
          Boolean(showDetails) ||
          (isChangeFlow && !isViewMode) ||
          (salesOrganizationList.length <= 0 && salesDataloadingCompleted)
      },
      {
        title: intl.formatMessage({ defaultMessage: "Sales Group" }),
        name:
          isChangeFlow && isViewMode ? "salesGroupCodeName" : "salesGroupCode",
        required: false,
        placeholder: intl.formatMessage({
          defaultMessage: "Sales Group"
        }),
        type: FIELD_TYPE.SINGLE_SELECT,
        options: salesGroupList,
        md: 12,
        isfieldVisibility: !showDetails
      },
      {
        title: intl.formatMessage({ defaultMessage: "Sales Employee" }),
        name: "salesEmployee",
        required: false,
        placeholder: intl.formatMessage({
          defaultMessage: "Sales Employee"
        }),
        type: FIELD_TYPE.NUMBER_INPUT,
        maxLength: 10,
        md: 12,
        isfieldVisibility: !showDetails,
        className: classes.salesEmployee
      }
    ],
    [
      salesOrganizationList,
      distributionChannelList,
      divisionList,
      orderTypeList,
      salesGroupList
    ]
  );

  return {
    formSalesData,
    salesOrganizationList
  };
};

export default useNotRefSales;
